import { Box, EmptyState, Grid, type GridProps } from '@chakra-ui/react'
import { HiColorSwatch } from 'react-icons/hi'
import { LoadingSpinner } from '../../feedback'

const DataGridLoadingState = () => {
	return <LoadingSpinner />
}

const DataGridEmptyState = () => {
	return (
		<EmptyState.Root>
			<EmptyState.Indicator>
				<HiColorSwatch />
			</EmptyState.Indicator>
			<EmptyState.Content>
				<EmptyState.Title>No result found</EmptyState.Title>
				<EmptyState.Description>
					Refresh or try again with different search
				</EmptyState.Description>
			</EmptyState.Content>
		</EmptyState.Root>
	)
}

export type DataGridStateProps = {
	isEmpty: boolean
	isLoading?: boolean
}

export const DataGridState = ({ isLoading, isEmpty }: DataGridStateProps) => {
	if (isLoading) return <DataGridLoadingState />

	if (isEmpty) return <DataGridEmptyState />

	return null
}

export type DataGridProps = {
  total: number | undefined
  isLoading?: boolean
  children: React.ReactNode
} & GridProps


export const DataGrid = ({
	total,
	isLoading,
	children,
	...other
}: DataGridProps) => {
  const isEmpty = total === 0 || !Boolean(total)
	const checkState = isLoading || isEmpty

	if (isLoading || isEmpty) {
		return (
			<Box>
				<DataGridState isLoading={isLoading} isEmpty={isEmpty} />
			</Box>
		)
	}

	return (
		<Grid {...other}>
			{checkState ? (
				<DataGridState isLoading={isLoading} isEmpty={isEmpty} />
			) : (
				children
			)}
		</Grid>
	)
}
